import React, { useState } from "react";
import Button from "../../../Button/Button";
import { ModalBody, ModalFooter, ModalHeader } from "../../../Modal/Modal";
import Search from "../../../Search/Search";
import EmptyState from "../../../EmptyState/EmptyState";
import PublishDetails from "../../../PublishDetails/PublishDetails";
import { PublishStatus } from "../../types";
import "./PublishDetailsModal.css";

interface PublishDetailsModalProps {
  publishStatuses: PublishStatus[];
  closeModal: () => undefined;
}

function PublishStatusList(props: Pick<PublishDetailsModalProps, "publishStatuses">) {
  const { publishStatuses } = props;
  return (
    <>
      {publishStatuses.map((status) =>
        <PublishDetails
          key={status.time}
          color={status.environment.color}
          environment={status.environment.name}
          version={`Version ${status.version}`}
          locale={status.locale}
          userName={status.userName}
          scheduledAt={status.time}
        />
      )}
    </>
  )
}

export function PublishDetailsModal(props: PublishDetailsModalProps) {
  const { publishStatuses, closeModal } = props;
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const search = (value: any) => {
    if (!value) {
      setSearchResults(publishStatuses)
      return;
    }
    const results = publishStatuses.filter((status) =>
      status.environment.name.toLowerCase().includes(value.toLowerCase()));
    setSearchValue(value)
    setSearchResults(results);
  }

  return (
    <div className="publish-details" data-test-id="publish-details-modal">
      <ModalHeader
        title={
          <div className="publish-details__title">
            <span>Publish Status</span>
            <span className="publish-details__count">{publishStatuses.length}</span>
          </div>
        }
        closeModal={closeModal}
      />
      <ModalBody>
        <Search
          placeholder="Search published entries"
          onChange={search}
          value={searchValue}
          width="full"
          type="secondary"
          onClear={true}
        />
        <div className="publish-details__status-list">
          {searchValue ?
            searchResults.length ? (
              <PublishStatusList publishStatuses={searchResults} />
            ) : (
              <EmptyState heading={'No results found'} displayImage={false} type="tertiary" />
            ) : (
              <PublishStatusList publishStatuses={publishStatuses} />
            )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="button" buttonType="tertiary" version="v2" onClick={closeModal} size="small" testId="publish-details-modal__close">
          <span>Cancel</span>
        </Button>
      </ModalFooter>
    </div>
  )
}
